import type { Config } from "../declarations/config.d.ts";

export const extraObjectsConfig: Config[] = [
  {
    name: "kopec",
    coordinates: {
      x: "1132",
      y: "331",
    },
    width: "766",
    layer: 4,
  },
  {
    name: "vanocni_strom",
    coordinates: {
      x: "1457",
      y: "196",
    },
    width: "360",
    layer: 6,
  },
];
